import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/Auth/auth.service';
import { inject } from '@angular/core';
import { LoadingService } from '../services/loading/loading.service';

export const sessionGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loading = inject(LoadingService);

  loading.show();

  return new Promise<boolean | UrlTree>((resolve, reject) => {
    authService.validateSession().subscribe({
      next: () => resolve(true),
      error: () => {
        authService.logout();
        resolve(router.createUrlTree(['/login']));
      },
      complete: () => loading.close()
    });
  });
};
